import { create } from "zustand";

interface NewCartStore {
  isCartOpen: boolean;
  setIsCartOpen: (open: boolean) => void;
  /** Items whose roll selection a quantity change just discarded; in memory only, so a refresh means No Preference */
  lostRollSelectionItemIds: string[];
  markRollSelectionLost: (itemId: string) => void;
  clearRollSelectionLost: (itemId: string) => void;
}

export const useNewCartStore = create<NewCartStore>(set => ({
  isCartOpen: false,
  setIsCartOpen: (isCartOpen: boolean) => set({ isCartOpen }),
  lostRollSelectionItemIds: [],
  markRollSelectionLost: itemId =>
    set(state => ({
      lostRollSelectionItemIds: [...state.lostRollSelectionItemIds.filter(id => id !== itemId), itemId],
    })),
  clearRollSelectionLost: itemId =>
    set(state => ({ lostRollSelectionItemIds: state.lostRollSelectionItemIds.filter(id => id !== itemId) })),
}));
